import { icons } from "~/ui";

export const ErrorAlert = ({
  error,
  onDismiss,
}: {
  error: Record<string, string[]>;
  onDismiss: () => void;
}) => (
  <div className="mb-4 flex w-full items-start gap-2 bg-red-100 p-4">
    <icons.solid.XCircleIcon className="mt-0.5 size-5 shrink-0 text-red-500" />

    <div className="min-w-0 flex-1">
      <p className="text-indigo mb-2 font-medium">
        The given data failed to pass validation.
      </p>
      <ul className="list-inside list-disc space-y-1 text-sm text-neutral-800">
        {Object.entries(error).flatMap(([field, messages]) =>
          messages.map((message, index) => (
            <li key={`${field}-${index}`}>{message}</li>
          )),
        )}
      </ul>
    </div>

    <button
      type="button"
      onClick={onDismiss}
      className="cursor-pointer self-start"
    >
      <icons.solid.XMarkIcon className="text-indigo size-5" />
    </button>
  </div>
);
